import styled from 'styled-components';

const MultiselectStepContainer = styled.div`
    max-width: fit-content;
    max-height: 70%;
    overflow-y: scroll;
    padding: 0 55px;
`;

export default MultiselectStepContainer;
